module.exports = __webpack_public_path__ + "img/9.23ba91f6.jpg";